import React from 'react'
import RowButton from 'components/atoms/row-button'
import TimeUtil from 'utils/time-util'
import ActiveStatusBadge from 'domains/cms-blog-post/atoms/active-status-badge'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import PropTypes from 'prop-types'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

/**
 * Related Article Landing Page Section Table Columns
 */
const CmsFeaturedSellerLandingPageRelatedArticleTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled
}) => {
  // Custom Cell
  // Used to modify the cell in specific columns

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        text={ buttonText }
        disabled={ disabled }
      />
    )
  }
  ActionCell.propTypes = actionCellPropTypes

  const DateCell = (row) => TimeUtil.format(row.cell.value)
  const UrlCell  = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/blog/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `blog/${row.cell.value}` }
    </a>
  )

  const ActiveStatusCell = (row) => <ActiveStatusBadge active_status={ row.cell.value } />

  return (
    [
      {
        Header  : 'Blogs',
        columns : [
          {
            Header         : 'Title',
            accessor       : 'title',
            disableFilters : true
          },
          {
            Header         : 'Category',
            accessor       : 'category',
            disableFilters : true
          },
          {
            Header         : 'Active Status',
            accessor       : 'active_status',
            disableFilters : true,
            Cell           : ActiveStatusCell
          },
          {
            Header         : 'Url Key',
            accessor       : 'url',
            disableFilters : true,
            Cell           : UrlCell
          },
          {
            Header         : 'Posted Date',
            accessor       : 'posted_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header : 'Action',
            id     : 'action',
            Cell   : ActionCell
          }
        ]
      }
    ]
  )
}

CmsFeaturedSellerLandingPageRelatedArticleTableColumns.propTypes = propTypes
export default CmsFeaturedSellerLandingPageRelatedArticleTableColumns
